import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { EvaluationModule } from 'app/assessment/evaluation/evaluation.module';
import { MaterialModule } from 'app/material.module';
import { NotificationModule } from 'app/notifications/notification.module';
import { RecommendationModule } from 'app/recommendation/recommendation.module';
import { SharedModule } from 'app/shared/shared.module';
import { TaskModule } from 'app/task/task.module';

import { HomeComponent } from './components/home.component';
import { MyZoneHelpDialogComponent } from './components/my-zone-help-dialog/my-zone-help-dialog.component';
import { MyZoneLoginBannerComponent } from './components/my-zone-login-banner/my-zone-login-banner.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    RecommendationModule,
    TaskModule,
    EvaluationModule,
    SharedModule,
    RecommendationModule,
    NotificationModule,
    TranslateModule,
  ],
  declarations: [HomeComponent, MyZoneHelpDialogComponent, MyZoneLoginBannerComponent],
  exports: [HomeComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  entryComponents: [
    MyZoneHelpDialogComponent,
    MyZoneLoginBannerComponent
  ],
})
export class HomeModule { }
